module.exports = __webpack_public_path__ + "img/rk_express.9c59ef65.jpg";